<div class="container">
  <div class="category">
    <h1 class="category__header">Most popular categories</h1>
    <div nz-row [nzGutter]="[16, 16]" class="category__content">
      @for (
        item of popularCategories
        | slice : 0 : siteData.lander.categories.limit
        ; track
        item) {
        <div
          nz-col
          nzXs="12"
          nzSm="12"
          nzMd="12"
          nzLg="6"
          class="category__content-item"
          >
          <a
            class="item-holder"
            routerLink="/job-list"
            [queryParams]="{ category: item.category }"
            >
            <i class="jobs-icon" [ngClass]="getIconCategory(item.category)"></i>
            <h1>{{ item.category }}</h1>
            <p>{{ item.jrCount }} Jobs available</p>
          </a>
        </div>
      }
    </div>
  </div>
</div>
